export default __webpack_public_path__ + "static/media/tma.46544aee.png";